import MemberList from "./MemberList";
import GenreList from "./GerneList";
import EpisodeList from "./EpisodeList";
import Poster from "./Poster";
import {useState} from "react";

function Serial(params) {
    const serial = params.serial;
    const [showEpisodes, setShowEpisodes] = useState(false);
    const user = params.user;

    return (
        <div style={{
            backgroundColor: '#fff',
            borderRadius: '16px',
            border: '1px solid #e5e7eb',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
        }}>
            <div style={{display: 'flex', gap: '20px', alignItems: 'flex-start'}}>

                <div style={{width: '150px', minWidth: '150px', flexShrink: 0}}>
                    <Poster link={serial.posterUrl}/>
                </div>

                <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: '6px'}}>
                    <h3 style={{margin: 0, fontSize: '18px', fontWeight: 'bold', color: '#111827'}}>
                        {serial.name}
                    </h3>
                    <div style={{fontSize: '14px', color: '#6b7280'}}>
                        {serial.nameOriginal}
                    </div>
                    <div style={{fontSize: '14px', fontWeight: '600', color: '#4f46e5'}}>
                        {serial.year} • {serial.season}
                    </div>

                    <div style={{marginTop: '5px'}}>
                        <GenreList genres={serial.genreSerials.map(t => t.genre.name)}/>
                    </div>

                    <div style={{display: 'flex', gap: '10px', marginTop: '15px'}}>
                        <button
                            onClick={() => params.onEditClicked(serial)}
                            style={{
                                padding: '10px 20px',
                                borderRadius: '10px',
                                border: 'none',
                                backgroundColor: '#4f46e5',
                                color: '#fff',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '600',
                                flex: 1
                            }}
                        >
                            Редагувати
                        </button>
                        <a href={serial.downloadUrl} target="_blank" style={{
                            padding: '10px 15px',
                            borderRadius: '10px',
                            fontSize: '14px',
                            textDecoration: 'none',
                            backgroundColor: '#f3f4f6',
                            color: '#374151',
                            border: '1px solid #d1d5db'
                        }}>Toloka</a>
                    </div>
                </div>
            </div>

            {/* Команда */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                padding: '12px 15px',
                backgroundColor: '#f9fafb',
                borderRadius: '10px',
                fontSize: '13px'
            }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <b style={{ color: '#4b5563', minWidth: '85px' }}>Переклад:</b>
                    <MemberList members={serial.translatorSerials.map(t => t.member)} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <b style={{ color: '#4b5563', minWidth: '85px' }}>Озвучка:</b>
                    <MemberList members={serial.voiceActorSerials.map(t => t.member)} />
                </div>
            </div>

            <div style={{
                fontSize: '14px',
                color: '#4b5563',
                lineHeight: '1.5',
                display: '-webkit-box',
                WebkitLineClamp: '3',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden'
            }}>
                {serial.description}
            </div>

            <div style={{ borderTop: '1px solid #f3f4f6', paddingTop: '10px' }}>
                <button
                    onClick={() => setShowEpisodes(!showEpisodes)}
                    style={{
                        width: '100%',
                        padding: '10px',
                        borderRadius: '10px',
                        border: '1px solid #e5e7eb',
                        backgroundColor: '#fff',
                        cursor: 'pointer',
                        color: '#4b5563',
                        fontSize: '13px',
                        fontWeight: '500'
                    }}
                >
                    {showEpisodes ? '🔼 Сховати серії' : '🔽 Показати серії'}
                </button>

                {showEpisodes && (
                    <div style={{ marginTop: '12px', maxHeight: '300px', overflowY: 'auto' }}>
                        <EpisodeList user={user} serialId={serial.id} />
                    </div>
                )}
            </div>
        </div>
    );
}

export default Serial;